<template>
    <v-app>
          <v-tabs
                    v-model="tab"
                    background-color="rgb(251, 251, 251)"
                    color="rgb(219, 241, 254)"
                    class="mt-lg-2"
                    >
                    <v-tab
                        v-for="item in items"
                        :key="item"
                         class="rounded-lg"
                        
                    >
                    <span class="tab-color"> {{ item }} </span>
                    </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                    <v-tab-item
                        v-for="item in items"
                        :key="item"
                    >
                        <v-card
                        color="rgb(251, 251, 251)"
                        flat class="px-lg-10 py-lg-5"
                        v-if="item == 'INDIVIDUAL'"
                        >
                        

                        <IndividualRating class="mt-lg-n5"/>
                       


                        </v-card>
                        <v-card
                        color="rgb(251, 251, 251)"
                        flat class="px-lg-10 py-lg-5"
                        v-if="item == 'GENERAL'"
                        >
                        
                        <GeneralRating class="mt-lg-n5"/>


                        </v-card>


                        

                    </v-tab-item>
                    </v-tabs-items>
      
       

    </v-app>
</template>
<style scoped>
.searchinput{
  width:300px !important;
}
</style>
<script>
import IndividualRating from '@/components/MonitoringRating/InvidualRating'
import GeneralRating from '@/components/MonitoringRating/GeneralRating'

export default {
    name: "Summary",
     components:{
     IndividualRating,
     GeneralRating
    },
    data: () => ({
      tab:null,
      items: [
            'INDIVIDUAL','GENERAL'
            ],
     
    }),
}
</script>